export const defaultAmisConvertState = {};

export default {
	...defaultAmisConvertState
};
